<div class="reset-page screen-bottom-halo">
  <div class="logo-container">
    <img class="logo-icon" src="assets/images/explain-logo-900.svg" alt="explain_logo" />
    <img class="logo-text" src="assets/images/explain-text-900.svg" alt="explain_text" />
  </div>

  <div class="reset-card">
    <!-- Loading state -->
    @if (state === 'loading') {
      <div class="loading-dots">
        <span class="loading-dot"></span>
        <span class="loading-dot"></span>
        <span class="loading-dot"></span>
      </div>
      <h2 class="card-title loading-title">{{ 'addin-connect.loading-title' | translate }}</h2>
      <p class="card-subtitle">{{ 'addin-connect.loading-subtitle' | translate }}</p>
    }

    <!-- Success state -->
    @if (state === 'success') {
      <div class="status-icon success-icon">
        <i class="ph-bold ph-check" style="font-size: 28px"></i>
      </div>
      <div class="card-header">
        <h2 class="card-title">{{ 'addin-connect.success-title' | translate }}</h2>
        <p class="card-subtitle">{{ 'addin-connect.success-subtitle' | translate }}</p>
      </div>
      <div class="form-actions">
        <button type="button" class="btn-secondary-action" (click)="redirectToProjects()">
          {{ 'addin-connect.go-to-projects' | translate }}
        </button>
      </div>
    }

    <!-- Error state -->
    @if (state === 'error') {
      <div class="status-icon error-icon-circle">
        @if (errorMessage === 'addin-connect.error-unauthorized') {
          <i class="ph ph-user-circle" style="font-size: 32px"></i>
        } @else {
          <i class="ph-bold ph-warning-circle" style="font-size: 28px"></i>
        }
      </div>
      <div class="card-header">
        @if (errorTitle) {
          <h2 class="card-title">{{ errorTitle | translate }}</h2>
        }
        <p class="card-subtitle" [class.mt-2]="!errorTitle" style="white-space: pre-line">{{ errorMessage | translate }}</p>
      </div>
      <div class="form-actions">
        @if (errorMessage === 'addin-connect.error-unauthorized') {
          <button type="button" class="btn-submit btn-login-cta" (click)="redirectToLogin()">
            {{ 'addin-connect.go-to-login' | translate }}
          </button>
        } @else {
          <button type="button" class="btn-submit btn-login-cta" (click)="closeOrRedirect()">
            {{ 'addin-connect.close-window' | translate }}
          </button>
        }
      </div>
    }
  </div>
</div>
